import { C } from "@/lib/brand";

// VOYA9 logo: italic serif "voya" + bold sans peach "9"
export default function Logo({ light = false, size = 22, testId = "voya9-logo" }) {
  const inkColor = light ? C.cream : C.ink;
  return (
    <span
      data-testid={testId}
      style={{
        display: "inline-flex",
        alignItems: "baseline",
        lineHeight: 1,
        fontSize: size,
        userSelect: "none",
      }}
    >
      <span
        style={{
          fontFamily: '"Instrument Serif", Georgia, serif',
          fontStyle: "italic",
          color: inkColor,
          fontSize: size * 1.1,
          letterSpacing: "-0.02em",
        }}
      >
        voya
      </span>
      <span
        style={{
          fontFamily: '"DM Sans", sans-serif',
          fontWeight: 800,
          color: light ? C.peach : C.peachDeep,
          fontSize: size,
          marginLeft: 1,
          letterSpacing: "-0.04em",
        }}
      >
        9
      </span>
    </span>
  );
}
